<template>
  <div class="choose-land-container">
    <div class="top-filter-wrapper">
      <div class="select-box">
        <!--  作物选择  -->
        <el-select
          v-model="cropGroupId"
          clearable
          :disabled="!!selectCropId"
          @change="searchLand"
          placeholder="按种养品种筛选"
          style="width: 224px; margin-right: 20px"
        >
          <el-option
            v-for="cropGroup in cropGroupList"
            :key="cropGroup.cropId"
            :value="cropGroup.cropId"
            :label="cropGroup.cropName"
          ></el-option>
        </el-select>
        <!--  地块编组选择  -->
        <el-select
          v-model="landGroupId"
          multiple
          collapse-tags
          @change="searchLand"
          placeholder="按地块编组筛选"
          style="width: 224px; margin-right: 20px"
        >
          <el-option
            v-for="landGroup in landGroupList"
            :key="landGroup.id"
            :value="landGroup.id"
            :label="landGroup.name"
          ></el-option>
        </el-select>
        <!--  搜索地块  -->
        <el-input
          v-model="landName"
          clearable
          @input="searchLand"
          placeholder="搜索地块名称"
          style="width: 220px"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <!--  模式切换按钮    -->
      <div class="btns-group">
        <div
          class="list-mode btn"
          :class="{ active: currentMode == 'ListMode' }"
          @click="changeMode('ListMode')"
        >
          列表模式
        </div>
        <div
          class="map-mode btn"
          :class="{ active: currentMode == 'MapMode' }"
          @click="changeMode('MapMode')"
        >
          地图模式
        </div>
      </div>
    </div>
    <!--  中间模式组件切换，组件切换使用 show 的方式，是为了地图不重复渲染    -->
    <div class="mode-wrapper">
      <transition name="el-fade-in-linear">
        <list-mode v-show="currentMode == 'ListMode'"></list-mode>
      </transition>
      <transition name="el-fade-in-linear">
        <map-mode ref="mapComp" :show="currentMode == 'MapMode'"></map-mode>
      </transition>
    </div>
    <!--  底部栏  -->
    <div class="footer-action-box">
      <div
        class="all-check"
        :class="{ checked: isSelectAllLand }"
        @click="handleSelectAll"
      >
        <div class="check-icon">
          <i class="iconfont icon-round-check"></i>
        </div>
        <span>全选</span>
      </div>
      <div class="bottom-right">
        <!-- <transition name="el-fade-in-linear"> -->
        <div
          placement="top"
          width="200"
          trigger="click"
          class="popover"
          v-if="hadSelectedLandList.length && showPopFlag"
        >
          <div class="popover-content">
            <div
              v-for="item in hadSelectedLandList"
              :key="item.id"
              class="popover-content-item"
            >
              <p class="land-name">{{ item.landName }}</p>
              <div class="content-center">
                <span class="land-arce"
                  >{{ item.statisticsLandAcre }}亩&nbsp;&nbsp;<i>{{
                    item.landGroupName
                  }}</i></span
                >
                <span class="group"></span>
                <img
                  src="@/assets/images/common/input_clear.png"
                  alt=""
                  @click="closeOneItem(item)"
                />
              </div>
              <el-tooltip placement="bottom">
                <div slot="content" v-for="(i, m) in item.cropList" :key="m">
                  {{
                    i.cropBreed ? i.cropName + "-" + i.cropBreed : i.cropName
                  }}：
                  {{ i.plantStartDate | formatDate("yyyy-MM-dd") }}
                  {{
                    i.cropSubjectIdentifier == "agri" ||
                    i.cropSubjectIdentifier == "forestry"
                      ? "种植"
                      : "养殖"
                  }}
                </div>

                <div class="crop-name" v-if="item.cropList.length">
                  <span v-for="(item, index) in item.cropList" :key="index">
                    {{
                      item.cropBreed
                        ? item.cropName + "-" + item.cropBreed
                        : item.cropName
                    }}
                    <i>、</i>
                  </span>
                </div>
              </el-tooltip>
              <div class="no-name" v-if="!item.cropList.length">未种养</div>
            </div>
          </div>
          <div class="content-bottom" @click="clearAll">
            <i class="clear-list-btn"></i>
            <span>清空</span>
          </div>
        </div>
        <!-- </transition> -->
        <div class="selected-info" @click="showPopover">
          <span slot="reference"
            >已选择<span>{{ hadSelectedLandList.length }}</span
            >个地块(共<span>{{ totalAcre }}</span
            >亩)</span
          >
          <i
            v-if="hadSelectedLandList.length"
            class="iconfont icon-shang1"
            :class="{ rotate: showPopFlag }"
          ></i>
        </div>
        <el-button class="submit-btn" @click="submitHandle">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ListMode from "./ListMode";
import MapMode from "./MapMode";
import { mapState, mapGetters } from "vuex";
import {
  getCropByCompanyId,
  getLandGroup,
  getLandList,
} from "@/api/request/snkd.produce";
import { getStrCharLen, cutStrByCharLen } from "@/utils";
import { getStorage } from "@/utils/storage";
export default {
  components: { ListMode, MapMode },
  props: {
    selectLandLists: {
      type: Array,
      default: () => [],
    },
    selectCropGroupId: {
      type: String,
      default: "",
    },
    selectCropId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      cropGroupId: "",
      landGroupId: [],
      landName: "",
      companyId: null,
      farmId: null,
      cropGroupList: [], //作物list
      landGroupList: [], //地块分组list
      showPopFlag: false, //pop弹出层
      dateList: [], //全部种植时间
    };
  },
  watch: {
    landName(val) {
      if (getStrCharLen(val) > 40) {
        this.landName = cutStrByCharLen(val, 20);
      }
    },
  },
  computed: {
    ...mapState("uplink", {
      filterLandCondition: "filterLandCondition",
      currentMode: "showLandMode",
      loading: "landLoading",
    }),
    ...mapGetters("uplink", [
      "hadSelectedLandList",
      "isSelectAllLand",
      "showLandList",
    ]),
    //求和
    totalAcre() {
      return this.calcLandAcre(this.hadSelectedLandList);
    },
  },
  async mounted() {
    // 过滤条件回显
    if (this.filterLandCondition !== null) {
      const { cropGroupId, landGroupIdArray, landName } =
        this.filterLandCondition;
      this.cropGroupId = cropGroupId;
      this.landGroupId = landGroupIdArray;
      this.landName = landName;
    }
    //如果当前是地图模式，手动加载一次地图
    if (this.currentMode === "MapMode") {
      this.$refs.mapComp.renderMap();
    }
    //获取农场id
    const farminfo = getStorage("FARMINFO");
    if (farminfo) {
      this.companyId = farminfo.companyId;
      this.farmId = farminfo.farmId;
    }
    await this.getCropListHandle();
    await this.getLandGroupListHandle();
    await this.getLandListHandle();
    //播种 默认选中空闲地块
    if (this.selectCropGroupId) {
      this.cropGroupId = this.selectCropGroupId;
      await this.searchLand(this.selectCropGroupId);
    }
    //采收 默认选中种养品种且不能编辑
    if (this.selectCropId) {
      this.cropGroupId = this.selectCropId * 1;
      await this.searchLand(this.selectCropId);
      this.dateList = this.showLandList.map((item) => {
        return {
          key: item.landStartTime,
          value: item.landStartTime
            ? new Date(item.landStartTime).format("yyyy-MM-dd")
            : "",
        };
      });
    }
  },
  methods: {
    //获取作物品种列表
    async getCropListHandle() {
      const res = await getCropByCompanyId({
        companyId: this.companyId,
        farmId: this.farmId,
      });
      if (res.obj.list) {
        this.cropGroupList = res.obj.list.concat([
          { cropId: "empty", cropName: "空闲地块" },
        ]);
      } else {
        this.cropGroupList = [];
      }
    },
    //获取地块分组列表
    async getLandGroupListHandle() {
      const res = await getLandGroup({
        companyId: this.companyId,
        farmId: this.farmId,
      });
      if (res.respCode == 0) {
        this.landGroupList = res.obj;
      } else {
        this.landGroupList = [];
      }
    },
    //获取地块列表
    async getLandListHandle() {
      //如果没有已选地块
      if (!this.hadSelectedLandList.length) {
        const res = await getLandList({
          companyId: this.companyId + "",
          farmId: this.farmId + "",
          disasterId: this.$route.query.id,
        });
        if (res.respCode == 0) {
          if (res.obj && res.obj.length) {
            res.obj.forEach((item) => {
              item.select = false;
            });
            this.processShowLandList(res.obj);
            if (this.selectLandLists && this.selectLandLists.length) {
              this.selectLandLists.forEach((item) => {
                this.$store.commit("uplink/changeSelectStatus", item.id);
              });
            }
          }
        }
      }
      // 请求结束，loading 状态设为 false
      this.$store.commit("uplink/changeLoadingStatus", false);
    },
    //选择地块确定
    submitHandle() {
      this.$emit("selectLandList", this.hadSelectedLandList);
      this.$store.commit("uplink/closeLand", true);
      this.$store.commit("uplink/clearPageAllStatus");
      this.$emit("submit");
    },
    //打开弹框
    showPopover() {
      if (this.hadSelectedLandList.length) {
        this.showPopFlag = !this.showPopFlag;
      }
    },
    //弹框删除单个地块
    closeOneItem(info) {
      this.$store.commit("uplink/changeSelectStatus", info.id);
      if (!this.hadSelectedLandList.length) {
        this.showPopFlag = false;
      }
    },
    //清空弹框
    clearAll() {
      this.hadSelectedLandList.forEach((item) => {
        this.$store.commit("uplink/changeSelectStatus", item.id);
      });
      this.showPopFlag = false;
    },
    //筛选条件
    searchLand() {
      const searchKey = {
        cropGroupId: this.cropGroupId || null,
        landGroupIdArray: this.landGroupId,
        landName: this.cropGroupId === "empty" ? "空闲地块" : this.landName,
      };
      this.$store.commit("uplink/filterLandList", searchKey);
    },
    //求和
    calcLandAcre(list) {
      const countStr = list
        .reduce((total, cur) => total + cur.statisticsLandAcre, 0)
        .toFixed(2);
      return parseFloat(countStr);
    },
    // 处理保存地块数据
    processShowLandList(data) {
      data.forEach((item) => {
        item.select = false;
        item.landId = item.id;
      });
      this.$store.commit("uplink/setLandList", data);
    },
    //切换tab
    changeMode(mode) {
      if (this.loading) {
        this.$message({
          message: "地块数据还在加载中",
          type: "warning",
        });
        return false;
      }
      if (mode === "MapMode" && this.showLandList.length > 3500) {
        this.$message({
          message: "地块数据太多，地图模式暂不可用",
          type: "warning",
        });
        return false;
      }
      this.$store.commit("uplink/changeShowLandMode", mode);
    },
    //全选
    handleSelectAll() {
      const data = {
        selectStatus: !this.isSelectAllLand,
        showLandList: this.showLandList,
      };
      this.$store.commit("uplink/selectAllLand", data);
      this.$refs.mapComp.renderMap();
    },
  },
};
</script>

<style lang="scss">
.choose-land-container {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  background: #ffffff;
  .top-filter-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 50px 30px 20px;
    background: #ffffff;
    .btns-group {
      display: flex;
      border: 1px solid $--color-primary;
      height: 36px;
      border-radius: 3px;
      overflow: hidden;
      cursor: pointer;
      .btn {
        width: 63px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 12px;
        background: #ffffff;
        color: $--color-primary;
        &.active {
          background: $--color-primary;
          color: #ffffff;
        }
      }
    }
  }
  .mode-wrapper {
    height: calc(100% - 110px - 67px);
    overflow: hidden;
  }
  .footer-action-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // position: absolute;
    // left: 0;
    // bottom: 0;
    width: 100%;
    height: 67px;
    background: #ffffff;
    box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.04);
    display: flex;
    align-items: center;
    .all-check {
      display: flex;
      margin: 0 32px 0 48px;
      cursor: pointer;
      .check-icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #e5e5e5;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 12px;
        i {
          font-size: 12px;
          color: #ffffff;
          margin: 0;
        }
      }
      span {
        font-size: 14px;
        line-height: 20px;
        color: #333333;
      }
      &.checked {
        .check-icon {
          background: $--color-primary;
          border: 0 none;
        }
        span {
          color: $--color-primary;
        }
      }
    }
    .selected-info {
      cursor: pointer;
      display: inline-block;
      font-size: 14px;
      line-height: 40px;
      color: #b2b2b2;
      span {
        color: $--color-primary;
      }
      .icon-shang1 {
        margin: 0;
        display: inline-block;
        font-size: 14px;
        color: #bfbfbf;
        transition: all 0.3s;

        &.rotate {
          transition: all 0.3s;
          transform: rotate(-180deg);
        }
      }
    }
    .next-btn {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 122px;
    }
    .submit-btn {
      margin-left: 20px;
      width: 90px;
      height: 35px;
      background: #64c3a4;
      border-radius: 30px;
      color: #fff;
      line-height: 10px;
      text-align: center;
      font-size: 14px;
      cursor: pointer;
    }
    .bottom-right {
      position: relative;
      margin-right: 30px;
    }
  }
  .popover {
    background-color: #fff;
    height: 348.82px;
    width: 376px;
    position: absolute;
    z-index: 99999;
    left: -125px;
    bottom: 50px;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
    .popover-content {
      overflow: auto;
      height: 320px;
      &::-webkit-scrollbar {
        display: none;
      }
      :hover {
        background-color: #f1f1f1;
      }
    }
    .popover-content-item {
      margin: 5px 5px;
      background-color: #fff;
      box-sizing: border-box;
      height: 68px;
      // display: flex;
      padding: 5px 0 5px 5px;
      // flex-direction: column;
      position: relative;
    }
    .content-bottom {
      cursor: pointer;
      font-size: 14px;
      color: #b2b2b2;
      width: 340px;
      height: 25px;
      margin-left: 15px;
      border-top: 1px solid #f1f1f1;
      display: flex;
      align-items: center;
      .clear-list-btn {
        display: inline-block;
        background: url("~@/assets/images/common/clear_all.svg");
        width: 19px;
        height: 19px;
        vertical-align: middle;
      }
    }
    ::before {
      content: "";
      position: absolute;
      border-left: 16px solid transparent;
      border-right: 16px solid transparent;
      border-top: 16px solid #fff;
      bottom: -16px;
      left: 50%;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
    }
  }
  .land-name {
    width: 100%;
    font-weight: 400;
    font-size: 13px;
    color: #2e333b;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    line-height: 15px;
  }
  .content-center {
    padding: 0 20px 0 5px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      cursor: pointer;
    }
  }
  .land-arce {
    display: inline-block;
    font-size: 10px;
    color: #b2b2b2;
    i {
      color: #888;
    }
  }

  .crop-name {
    display: inline-block;
    box-sizing: border-box;
    // max-width: 270px;
    padding: 3px 9px;
    color: #ff831e;
    font-size: 12px;
    background: #fff2e8;
    border-radius: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    width: fit-content;
    max-width: 300px;
    span:last-child i {
      display: none;
    }
  }
}
.no-name {
  background: #f7f9fb;
  font-size: 12px;
  padding: 3px 9px;
  border-radius: 10px;
  color: #cccccc;
  width: 45px;
}
</style>
